import React, { useEffect,useState, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/cities/citiesActions";
import * as crud from "../../../_redux/cities/citiesCrud";

import * as uiHelpers from "../CitiesUIHelpers";
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { getRowStyleByStatus } from "../../../_helpers/tableRowStatusColors";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useCitiesUIContext } from "../CitiesUIContext";

export function CitiesTable() {
  const {user} = useSelector(state => state.auth);
  const userobject = user.userData;
  var superadmin = true;
  if (userobject.admin_role && userobject.admin_role !== 'superadmin' && userobject.is_admin) { superadmin = false; }

  // Cities UI Context
  const citiesUIContext = useCitiesUIContext();
  const citiesUIProps = useMemo(() => {
    return {
      ids: citiesUIContext.ids,
      setIds: citiesUIContext.setIds,
      queryParams: citiesUIContext.queryParams,
      setQueryParams: citiesUIContext.setQueryParams,
      openEditCityPage: citiesUIContext.openEditCityPage,
      openDeleteCityDialog: citiesUIContext.openDeleteCityDialog,
    };
  }, [citiesUIContext]);

  // Getting curret state of cities list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.cities }),
    shallowEqual
  );

  const delay = ms => new Promise(res => setTimeout(res, ms));

  const { totalCount, entities, listLoading } = currentState;
  const [processing, setProcessing] = useState('');
  const [isEdit, setisEdit] = useState('');
  const [nameValue, setNameValue] = useState('');

  // Cities Redux state
  const dispatch = useDispatch();

  const updateStatus = async (id, status) => {
    setProcessing(id);
    await crud.updateStatusForCity(id, status);
    dispatch(actions.fetchCities(citiesUIProps.queryParams));
    setProcessing('');
  };
  const isApprovalTab = ["approved", "pending", "rejected"].includes(window.location.pathname.split("/")[2]);
  const rowStyle = (row) => getRowStyleByStatus(row, isApprovalTab ? 'approval_status' : 'status');

  const editCity = async (row) => {
    setisEdit(row.id);
    setNameValue(row.name);
  };
  
  const saveCity = async (row) => {
    setProcessing("save" + row.id);
    await crud.updateRecordForCity(row.id, nameValue);
    dispatch(actions.fetchCities(citiesUIProps.queryParams));
    setisEdit('');
    setProcessing('');
  };

  useEffect(() => {
    // clear selections list
    citiesUIProps.setIds([]);
    // server call by queryParams
    dispatch(actions.fetchCities(citiesUIProps.queryParams));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [citiesUIProps.queryParams, dispatch]);
  // Table columns
  let columns = [
    {
      attrs: { title: 'Name' },
      dataField: "name",
      text: "Name",
      formatter: columnFormatters.NameColumnFormatter,
      formatExtraData: {
        isEdit: isEdit,
        setNameValue: setNameValue,
        nameValue: nameValue,
      },
      sort: true,
      sortCaret: sortCaret,
    },
    {
      attrs: { title: 'Country' },
      dataField: "country.name",
      text: "Country",
      formatter: (cell, row) => row.country ? row.country.name : '',
      sort: true,
    },
    {
      attrs: { title: 'State' },
      dataField: "state.name",
      text: "State",
      formatter: (cell, row) => row.state ? row.state.name : '',
      sort: true,
    },
    {
      attrs: { title: 'Status' },
      dataField: "status",
      text: "Status",
      formatter: columnFormatters.StatusColumnFormatter,
      formatExtraData: {
        updateStatus: updateStatus,
        superadmin: superadmin,
        processing: processing,
      },
      sort: true,
      sortCaret: sortCaret,
    },
  ];
  if(superadmin)
  {
    columns.push({
      attrs: { title: 'Actions' },
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        editCity:editCity,
        saveCity:saveCity,
        isEdit:isEdit,
        processing:processing,
        setisEdit:setisEdit,
      },
      
      style: {
        minWidth: "100px",
      },
    })
  }
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: citiesUIProps.queryParams.pageSize,
    page: citiesUIProps.queryParams.pageNumber,
  };
  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="custom-res-table table table-head-custom table-head-bg table-vertical-center"
                bootstrap4
                bordered={false}
                remote
                keyField="id"
                data={entities === null ? [] : entities}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                rowStyle={ rowStyle } 
                onTableChange={getHandlerTableChange(
                  citiesUIProps.setQueryParams
                )}
                selectRow={getSelectRow({
                  entities,
                  ids: citiesUIProps.ids,
                  setIds: citiesUIProps.setIds,
                })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
